import React from 'react';
import {
  SwitchLabelContainer,
  SwitchContainer,
  SwitchInput,
  SwitchTrack,
  SwitchThumb,
  SwitchLabel,
  SwitchToggleWrapper
} from './styled';

export interface SwitchProps {
  id: string;
  name: string;
  label: string;
  isChecked?: boolean;
  onChangeHandler: (e: React.ChangeEvent<HTMLInputElement>) => void;
  cypress?: string;
  disabled?: boolean;
  stat?: string;
}

export const Switch = ({
  id,
  name,
  label,
  isChecked = false,
  onChangeHandler,
  cypress,
  disabled = false,
  stat
}: SwitchProps) => (
  <SwitchLabelContainer data-stat={stat}>
    <SwitchContainer data-cy={`${cypress}-container`}>
      <SwitchLabel tag="body_1" data-cy={`${cypress}-label`}>
        {label}
      </SwitchLabel>
      <SwitchToggleWrapper>
        <SwitchInput
          type="checkbox"
          id={`Switch_${id}`}
          name={name}
          checked={isChecked}
          onChange={onChangeHandler}
          data-cy={`${cypress}-input`}
          disabled={disabled}
        />
        <SwitchTrack data-cy={`${cypress}-track`}>
          <SwitchThumb />
        </SwitchTrack>
      </SwitchToggleWrapper>
    </SwitchContainer>
  </SwitchLabelContainer>
);
